import { type ForwardedRef, forwardRef } from 'react';
import type { OptionTypeBase } from 'react-select';
import type { Props as ReactSelectAsyncProps } from 'react-select/async';

import { BaseSelect } from './BaseSelect';
import { SelectType } from './SelectType';
import type { CustomizeMenuPortaling } from './types';

export type AsyncSelectProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = CustomizeMenuPortaling<ReactSelectAsyncProps<OptionType, IsMulti>>;

export const AsyncSelect = forwardRef(
  <OptionType extends OptionTypeBase, IsMulti extends boolean>(
    props: AsyncSelectProps<OptionType, IsMulti>,
    forwardedRef: ForwardedRef<unknown>,
  ) => (
    <BaseSelect
      customRef={forwardedRef}
      selectType={SelectType.ASYNC}
      selectProps={props}
    />
  ),
);
AsyncSelect.displayName = 'AsyncSelect';
